import { toPence } from './LineItemsTable';

export const VAT_RATES = ['20', '5', '0'];
export const moneyInput = (pence) => (pence / 100).toFixed(2);
export const VAT_UNKNOWN_NOTE = "VAT not read — enter it from the invoice (0 if there's none)";

/** The rate this invoice is known to carry: the AI read first, then what was saved. */
export function knownVatRate(item) {
  const ai = item?.ai_totals;
  if (ai && ai.vat_rate != null && ai.net_pounds > 0) return ai.vat_rate;
  if (item?.net_pence > 0 && item?.vat_pence != null) return Math.round((item.vat_pence * 1000) / item.net_pence) / 10;
  return null;
}

/** VAT summed from the lines' own rates — only when every line carries one. */
export function vatFromLineRates(lines) {
  if (!lines.length || !lines.every(l => l.vat_rate != null && l.vat_rate !== '')) return null;
  return lines.reduce((s, l) => s + Math.round((toPence(l.amount) * Number(l.vat_rate)) / 100), 0);
}

/** Net changed (typed or following the lines): recalculate the VAT at the invoice's known rate and flag it for a check. */
export function recalcVat(netPence, form, lines, item) {
  const unchanged = { vat: form.vat, vat_status: form.vat === '' ? 'unknown' : 'check', vat_note: form.vat === '' ? VAT_UNKNOWN_NOTE : 'Net changed — re-check the VAT against the invoice' };
  if (netPence <= 0) return unchanged;
  const fromLines = vatFromLineRates(lines);
  if (fromLines != null) return { vat: moneyInput(fromLines), vat_status: 'check', vat_note: 'VAT worked out from the line rates — check it against the invoice' };
  const rate = knownVatRate(item);
  if (rate != null) return { vat: moneyInput(Math.round((netPence * rate) / 100)), vat_status: 'check', vat_note: `VAT recalculated at ${rate}% — check it against the invoice` };
  return unchanged;
}

/** Mirror of the server rule: line rates must reconcile with the invoice VAT. Returns a message or null. */
export function lineRateIssue(lines, vatPence) {
  const rated = lines.filter(l => l.vat_rate != null && l.vat_rate !== '');
  if (!rated.length) return null;
  const fixed = rated.reduce((s, l) => s + Math.round((toPence(l.amount) * Number(l.vat_rate)) / 100), 0);
  const rest = lines.length - rated.length;
  const bad = rest > 0 ? fixed > vatPence : Math.abs(vatPence - fixed) > Math.max(2, lines.length);
  if (!bad) return null;
  return `Line VAT rates add up to ${(fixed / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })} but the invoice VAT is ${(vatPence / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })} — fix the rates or clear them to split pro-rata`;
}

export const totalsSourceFor = (totalMode, aiMatches) => (totalMode === 'imported' ? (aiMatches ? 'ai' : undefined) : totalMode === 'auto' ? 'lines' : 'manual');
export const totalModeFor = (item) => (item?.totals_source === 'manual' ? 'manual' : item?.totals_source === 'lines' ? 'auto' : 'imported');
